import React from "react";
import { ActionButton, Card, StatusPill } from "./inventory-ui";
import { formatDate } from "../utils/inventory.utils";

export default function InboundReceiptsTab({
  inboundLoading,
  inboundItems,
  warehouseMap,
  openInboundDetails,
  openConfirmInbound,
  detailsLoading,
  pagination,
}) {
  return (
    <Card className="flex h-[500px] flex-col overflow-hidden">
      <div className="border-b border-[#f4d8dc] px-5 py-4">
        <div className="text-[18px] font-bold text-slate-800">
          Inbound Receipts
        </div>
      </div>

      <div className="min-h-0 flex-1 overflow-auto">
        {inboundLoading ? (
          <div className="p-5 text-[13px] text-slate-500">
            Loading inbound receipts...
          </div>
        ) : inboundItems.length === 0 ? (
          <div className="p-5 text-[13px] text-slate-500">
            No inbound receipts found.
          </div>
        ) : (
          <table className="w-full min-w-[860px]">
            <thead className="bg-[#fff7f8] text-left text-[12px] uppercase tracking-[0.12em] text-slate-500">
              <tr>
                <th className="px-5 py-3">Receipt</th>
                <th className="px-5 py-3">Warehouse</th>
                <th className="px-5 py-3">Status</th>
                <th className="px-5 py-3">Items</th>
                <th className="px-5 py-3">Created At</th>
                <th className="px-5 py-3">Note</th>
                <th className="w-[140px] px-5 py-3 text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {inboundItems.map((item) => (
                <tr
                  key={item.id}
                  className="border-t border-[#f8dde1] text-[13px] text-slate-700"
                >
                  <td className="px-5 py-4">
                    <div className="font-semibold text-slate-800">
                      {item.receiptCode ||
                        `INB-${String(item.id || "")
                          .replace(/-/g, "")
                          .slice(0, 8)
                          .toUpperCase()}`}
                    </div>
                  </td>

                  <td className="px-5 py-4">
                    {warehouseMap[item.warehouseId] || item.warehouseId}
                  </td>

                  <td className="px-5 py-4">
                    <StatusPill value={item.status} />
                  </td>

                  <td className="px-5 py-4">{item.itemsCount || 0}</td>

                  <td className="px-5 py-4">{formatDate(item.createdAt)}</td>

                  <td className="px-5 py-4">{item.note || "-"}</td>

                  <td className="w-[220px] px-5 py-4 text-center">
                    <div className="flex items-center justify-center gap-2">
                      <ActionButton
                        variant="soft"
                        onClick={() => openInboundDetails(item.id)}
                        className="min-w-[80px] px-3 py-2"
                        disabled={detailsLoading}
                      >
                        View
                      </ActionButton>

                      {String(item.status || "").toLowerCase() === "pending_batch" ? (
                        <ActionButton
                          onClick={() => openConfirmInbound(item.id)}
                          className="min-w-[96px] px-3 py-2"
                        >
                          Confirm
                        </ActionButton>
                      ) : null}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
       {pagination}
    </Card>
  );
}